"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import r from "../components/Icon/SvgIcon.js";
const t = (e) => /* @__PURE__ */ o(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.7 7.474a.75.75 0 0 1-.007 1.213l-4.505 3.243A.75.75 0 0 1 16 11.32v-.198l-.001-.044v-.336c0-.222 0-.537-.645-.5-1.932.11-6.249 1.168-8.052 4.507-.133.245-.557.334-.484-.334.162-2.782 2.272-7.287 8.536-8.514l.088-.016c.252-.043.557-.096.557-.485v-.336L16 5.03v-.263a.75.75 0 0 1 1.194-.604zM4.63 5.375A2.625 2.625 0 0 0 2.005 8v10.35a2.625 2.625 0 0 0 2.625 2.625h10a2.625 2.625 0 0 0 2.625-2.625V15a.625.625 0 1 0-1.25 0v3.35c0 .76-.616 1.375-1.375 1.375h-10c-.76 0-1.375-.616-1.375-1.375V8c0-.76.616-1.375 1.375-1.375h2.987a.625.625 0 0 0 0-1.25z",
        clipRule: "evenodd"
      }
    )
  }
), v = l(t);
export {
  v as Share,
  v as default
};
